import { render, staticRenderFns } from "./TooltipAjuda.vue?vue&type=template&id=2f772edf&lang=html&"
import script from "./TooltipAjuda.vue?vue&type=script&lang=js&"
export * from "./TooltipAjuda.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/shared-components/TooltipAjuda.vue
// module id = 78
// module chunks = 28